import React from 'react'

const Thirty_seven = () => {
    return (
        <div className='container'>
            <h1>C program to find the value of nCr(Combination) using function</h1>
            <div className='containers'>
            This C program is to find the value of nCr(Combination) using function. <br /> For example, value of nCr(Combination) using function of 5C3  will be nCr= 10.
            <h3>Logic</h3> 
To find combination we use the concept of finding factorial of a number and use the <br />
 standard formula for nCr=n!/r!*(n-r)! .
            </div>
            <h3>Dry Run of the Program</h3>

            Take input n=5 and r=3 <br />

ncr=fact(n)/fact(r)*fact(n-r) i.e. npr=fact(5)/fact(3)*fact(5-3)  i.e. npr=fact(5)/fact(3)*fact(2)<br />
<br />
Now function fact() is called.<br />
<br />
We now calculate fact(5),fact(3) and fact(2)<br />
<br />
int fact(int n)<br />
<br />
n=5<br />
<br />
Initialize f=1;<br />
<br />
1st iteration for(i=1;i&lt;=n;i++)  i.e. for(i=1;1&lt;=5;i++)<br />
<br />
f=f*i; i.e. f=1*1  i.e. f=1<br />
<br />
2nd iteration for(i=2;i&lt;=n;i++)  i.e. for(i=2;2&lt;=5;i++)<br />
<br />
f=f*i; i.e. f=1*2  i.e. f=2<br />
<br />
3rd iteration for(i=3;i&lt;=n;i++)  i.e. for(i=3;3&lt;=5;i++)<br />
<br />
f=f*i; i.e. f=2*3  i.e. f=6<br />
<br />
4th iteration for(i=4;i&lt;=n;i++)  i.e. for(i=4;4&lt;=5;i++)<br />
<br />
f=f*i; i.e. f=6*4  i.e. f=24<br />
<br />
5th iteration for(i=5;i&lt;=n;i++)  i.e. for(i=5;5&lt;=5;i++)<br />
<br />
f=f*i; i.e. f=24*5  i.e. f=120<br />
<br />
Now we break out of the for loop as i will now be greater than n(5).<br />
<br />
In a similar way, we calculate fact(3) & fact(2) for which answer will be 2<br />
<br />
Hence 5c3 = 120/6*2 = 10.<br />
<div className='containers'>
<code className='library'> #include</code> &lt;stdio.h&gt; <br/>
 
<code className='keywords'>int</code> fact(int);<br/>
  
<code className='library'>void</code>  main()<br/>
 &#123; <br/>
 <code className='keywords'> int</code> n,r,ncr;<br/>
  <br/>
  <code className='library'>printf</code>("Enter a number n\n");<br/>
  <code className='library'>scanf</code>("%d",&n);<br/>
  <code className='library'>printf</code>("Enter a number r\n");<br/>
  <code className='library'>   scanf</code>("%d",&r);<br/>
       ncr=fact(n)/(fact(r)*fact(n-r));<br/>
       <code className='keywords'>   printf</code> ("Value of %dC%d = %d\n",n,r,ncr);<br/>
 &#125; <br/>
  <br/>
  <code className='keywords'>int</code> fact(int n)<br/>
 &#123; <br/>
 <code className='keywords'>  int</code> i,f=1;<br/>
 <code className='keywords'>  for</code>(i=1;i&lt;=n;i++)<br/>
     &#123; <br/>
         f=f*i;<br/>
     &#125; <br/>
     <code className='library'>  return </code>f;<br/>
 &#125; <br/>
</div>
        </div>
    )
}

export default Thirty_seven
